import { SchemaModel } from '../../../../models/schemaModel';
import SmscForm, { SmscDataForm } from '../../components/smsc/SmscForm';
import SmscApi from '../../../../api/smscApi';
import { useAppDispatch } from '../../../../store/hooks';
import { fetchSchemaByName } from '../../../../store/schemas/schemasActions';
import { LogLevel } from '../../../../types/logLevel';
import { SmscObject } from '../../../../models/smscModel';
import { DEFAULT_SMSC_CONNECTION_CONFIG } from '../../components/smsc/SmscConnectionsFields';
import { AppErrorList, useAppErrorList } from '../../../../shared/components/AppErrorList';
import React from 'react';

type Props = {
  readonly schema: SchemaModel;
  readonly hideSmscForm: () => void;
};

const SmscAddFormContainer = (props: Props) => {
  const { schema, hideSmscForm } = props;
  const dispatch = useAppDispatch();
  const [{ errors, hasErrors }, { addError, removeError }] = useAppErrorList();

  const handleAddSmsc = (smsc: SmscObject) => {
    const schemaName = schema.name;

    SmscApi.addSmsc(schemaName, smsc)
      .then(() => {
        dispatch(fetchSchemaByName(schemaName));
        hideSmscForm();
      })
      .catch(addError);
  }

  const initialValues = {
    logLevel: LogLevel.DEBUG,
    connections: [DEFAULT_SMSC_CONNECTION_CONFIG],
  } as SmscDataForm;

  return (
    <>
      { hasErrors && (
        <AppErrorList
          errors={errors}
          onCloseError={removeError}
        />
      )}

      <SmscForm
        title='Add smsc'
        initialValues={initialValues}
        onSubmit={handleAddSmsc}
        onCancel={hideSmscForm}
        readOnly={false}
      />
    </>
  );
};

export default SmscAddFormContainer;
